"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInstallerUrls = exports.getInfo = exports.setBranding = exports.deregisterStatusCallback = exports.registerStatusCallback = exports.getInstallerInfo = exports.initDragDrop = exports.removeDropzone = exports.createDropzone = exports.modifyTransfer = exports.showPreferences = exports.showSelectFolderDialog = exports.showSelectFileDialog = exports.getTransfer = exports.getAllTransfers = exports.resumeTransfer = exports.stopTransfer = exports.showDirectory = exports.removeTransfer = exports.deregisterActivityCallback = exports.registerActivityCallback = exports.launch = exports.startTransfer = exports.testConnection = exports.init = exports.isSafari = exports.asperaSdk = void 0;
var aspera_sdk_model_1 = require("./models/aspera-sdk.model");
var core_1 = require("./app/core");
Object.defineProperty(exports, "createDropzone", { enumerable: true, get: function () { return core_1.createDropzone; } });
Object.defineProperty(exports, "deregisterActivityCallback", { enumerable: true, get: function () { return core_1.deregisterActivityCallback; } });
Object.defineProperty(exports, "deregisterStatusCallback", { enumerable: true, get: function () { return core_1.deregisterStatusCallback; } });
Object.defineProperty(exports, "getAllTransfers", { enumerable: true, get: function () { return core_1.getAllTransfers; } });
Object.defineProperty(exports, "getInfo", { enumerable: true, get: function () { return core_1.getInfo; } });
Object.defineProperty(exports, "getTransfer", { enumerable: true, get: function () { return core_1.getTransfer; } });
Object.defineProperty(exports, "init", { enumerable: true, get: function () { return core_1.init; } });
Object.defineProperty(exports, "initDragDrop", { enumerable: true, get: function () { return core_1.initDragDrop; } });
Object.defineProperty(exports, "modifyTransfer", { enumerable: true, get: function () { return core_1.modifyTransfer; } });
Object.defineProperty(exports, "registerActivityCallback", { enumerable: true, get: function () { return core_1.registerActivityCallback; } });
Object.defineProperty(exports, "registerStatusCallback", { enumerable: true, get: function () { return core_1.registerStatusCallback; } });
Object.defineProperty(exports, "removeDropzone", { enumerable: true, get: function () { return core_1.removeDropzone; } });
Object.defineProperty(exports, "removeTransfer", { enumerable: true, get: function () { return core_1.removeTransfer; } });
Object.defineProperty(exports, "resumeTransfer", { enumerable: true, get: function () { return core_1.resumeTransfer; } });
Object.defineProperty(exports, "setBranding", { enumerable: true, get: function () { return core_1.setBranding; } });
Object.defineProperty(exports, "showDirectory", { enumerable: true, get: function () { return core_1.showDirectory; } });
Object.defineProperty(exports, "showPreferences", { enumerable: true, get: function () { return core_1.showPreferences; } });
Object.defineProperty(exports, "showSelectFileDialog", { enumerable: true, get: function () { return core_1.showSelectFileDialog; } });
Object.defineProperty(exports, "showSelectFolderDialog", { enumerable: true, get: function () { return core_1.showSelectFolderDialog; } });
Object.defineProperty(exports, "startTransfer", { enumerable: true, get: function () { return core_1.startTransfer; } });
Object.defineProperty(exports, "stopTransfer", { enumerable: true, get: function () { return core_1.stopTransfer; } });
Object.defineProperty(exports, "testConnection", { enumerable: true, get: function () { return core_1.testConnection; } });
var installer_1 = require("./app/installer");
Object.defineProperty(exports, "getInstallerInfo", { enumerable: true, get: function () { return installer_1.getInstallerInfo; } });
var helpers_1 = require("./helpers/helpers");
Object.defineProperty(exports, "getInstallerUrls", { enumerable: true, get: function () { return helpers_1.getInstallerUrls; } });
Object.defineProperty(exports, "isSafari", { enumerable: true, get: function () { return helpers_1.isSafari; } });
var httpGatewayCalls = __importStar(require("./http-gateway"));
exports.asperaSdk = new aspera_sdk_model_1.AsperaSdk();
exports.asperaSdk.init = core_1.init;
exports.asperaSdk.testConnection = core_1.testConnection;
exports.asperaSdk.startTransfer = core_1.startTransfer;
exports.asperaSdk.registerActivityCallback = core_1.registerActivityCallback;
exports.asperaSdk.deregisterActivityCallback = core_1.deregisterActivityCallback;
exports.asperaSdk.removeTransfer = core_1.removeTransfer;
exports.asperaSdk.showDirectory = core_1.showDirectory;
exports.asperaSdk.stopTransfer = core_1.stopTransfer;
exports.asperaSdk.resumeTransfer = core_1.resumeTransfer;
exports.asperaSdk.getAllTransfers = core_1.getAllTransfers;
exports.asperaSdk.getTransfer = core_1.getTransfer;
exports.asperaSdk.showSelectFileDialog = core_1.showSelectFileDialog;
exports.asperaSdk.showSelectFolderDialog = core_1.showSelectFolderDialog;
exports.asperaSdk.showPreferences = core_1.showPreferences;
exports.asperaSdk.modifyTransfer = core_1.modifyTransfer;
exports.asperaSdk.createDropzone = core_1.createDropzone;
exports.asperaSdk.removeDropzone = core_1.removeDropzone;
exports.asperaSdk.getInstallerInfo = installer_1.getInstallerInfo;
exports.asperaSdk.registerStatusCallback = core_1.registerStatusCallback;
exports.asperaSdk.deregisterStatusCallback = core_1.deregisterStatusCallback;
exports.asperaSdk.initDragDrop = core_1.initDragDrop;
exports.asperaSdk.setBranding = core_1.setBranding;
exports.asperaSdk.getInfo = core_1.getInfo;
exports.asperaSdk.isSafari = helpers_1.isSafari;
exports.asperaSdk.getInstallerUrls = helpers_1.getInstallerUrls;
exports.asperaSdk.httpGatewayCalls = httpGatewayCalls;
var launch = exports.asperaSdk.globals.launch;
exports.launch = launch;
exports.asperaSdk.launch = launch;
if (typeof window === 'object') {
    window.asperaSdk = exports.asperaSdk;
}
exports.default = exports.asperaSdk;
